var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDimensionCuboid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 102,
    viewBox: "0 0 116 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    stroke: "#AFC2D6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 29H72V74H22V29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 15H90V60H72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 29L40 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 29L90 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 74L90 60"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#8FA7C1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 78H80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 78L75 75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 78L75 81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 78L19 75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 78L19 81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 24V78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 24L15 29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 24L21 29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 78L15 73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 78L21 73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 76L96 64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 64L90 64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 64L94 69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 76L83 70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 76L88 76"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#BFD0E2",
    fontFamily: "Arial",
    fontSize: 11,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 92
  }, "W"), /*#__PURE__*/React.createElement("text", {
    x: 6,
    y: 53
  }, "H"), /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 80
  }, "L"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimensionCuboid);
export default __webpack_public_path__ + "static/media/dimension-cuboid.09a1f397a20e69b2ac3b10d925402fdf.svg";
export { ForwardRef as ReactComponent };